import React from "react";
import { Link } from "react-router-dom";

export default function LegalFooter({ tone = "dark" }) {
  const isLight = tone === "light";
  const color = isLight ? "#8C8278" : "#8C8278";
  const linkColor = isLight ? "#111D33" : "#E8D5A3";
  return (
    <div
      className={"py-6 px-6 sm:px-10 " + (isLight ? "bg-transparent" : "")}
      style={{ borderTop: isLight ? "1px solid #F0EAE0" : "1px solid #1B2A4A" }}
      data-testid="legal-footer"
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-center">
        <p className="label-ui text-[10px] tracking-[0.25em]" style={{ color }} data-testid="legal-copyright">
          © {new Date().getFullYear()} THE LIVING BOOK · UNITED KINGDOM
        </p>
        <nav className="flex flex-wrap items-center gap-x-6 gap-y-2" data-testid="legal-footer-links">
          <Link to="/privacy" className="label-ui text-[10px] tracking-[0.2em] transition-colors" style={{ color: linkColor }} data-testid="legal-privacy-link">
            PRIVACY
          </Link>
          <Link to="/terms" className="label-ui text-[10px] tracking-[0.2em] transition-colors" style={{ color: linkColor }} data-testid="legal-terms-link">
            TERMS
          </Link>
          <a href="mailto:hello@thelivingbook.io" className="label-ui text-[10px] tracking-[0.2em] transition-colors" style={{ color: linkColor }} data-testid="legal-contact-link">
            CONTACT
          </a>
        </nav>
      </div>
    </div>
  );
}
